import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            探索兴趣圈子
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大核心兴趣圈子，总有一个属于你的天地。点击进入，发现志同道合的伙伴。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={category.image}
                  alt={`${category.name}兴趣圈子`}
                  title={`蘑菇社区${category.name}兴趣圈子`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4 flex items-center gap-2">
                  <div className="w-10 h-10 rounded-lg bg-white/90 flex items-center justify-center">
                    <i className={`${category.icon} text-lg text-primary-500`}></i>
                  </div>
                  <div className="text-white">
                    <h3 className="font-heading font-semibold text-base">{category.name}</h3>
                    <p className="text-xs text-white/70">{category.memberCount.toLocaleString()} 位成员</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{category.description}</p>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-article-line"></i>
                    {category.articleCount.toLocaleString()} 篇文章
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {category.memberCount.toLocaleString()} 成员
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}